import { render, staticRenderFns } from "./drag.vue?vue&type=template&id=72c7dc3a"
import script from "./drag.vue?vue&type=script&lang=js"
export * from "./drag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72c7dc3a')) {
      api.createRecord('72c7dc3a', component.options)
    } else {
      api.reload('72c7dc3a', component.options)
    }
    module.hot.accept("./drag.vue?vue&type=template&id=72c7dc3a", function () {
      api.rerender('72c7dc3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/list/drag.vue"
export default component.exports